import React from "react"
import styled from 'styled-components'

const H2 = styled.h2`
  span {
    display: inline-block;
    font-size: 2.6rem;
    font-weight: 700;
  }
`

const Title = ({ children, sub }) => {
  return (
    <H2>{children}<span>{sub}</span></H2>
  )
}

export default Title 